import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recordatorios',
  templateUrl: './recordatorios.component.html',
  styleUrls: ['./recordatorios.component.css']
})
export class RecordatoriosModalComponent implements OnInit {
  @Input() recordatorios: Array<any>;
  @Input() modals: any;
  loading = false;
  completado = false;
  constructor(public activeModal: NgbActiveModal, private empleadoService: EmpleadosServicio, private route: Router) { }

  ngOnInit() {
  }

  completarRecordatorio(data) {
    const arr = [];
    arr.push(data);
    this.loading = true;
    this.empleadoService.completarRecordatorios(arr)
    .subscribe(res => {
      this.modals.correctoModalJquery('Recordatorio completado', 'green', 'modern', 'fa fa-clock-o');
      if (data.ID_NOTA_CLIENTE === parseFloat(res[0].ID_NOTA_CLIENTE)) {
        data.completado = 1;
      }

      for (const item of this.recordatorios) {
        if (item.completado !== 0) {
          this.completado = true;
        } else {

          this.completado = false;
        }
      }

      setTimeout(() => {
        this.loading = false;
      }, 1);
    });
  }

  completarTodosRecordatorios() {
    this.loading = true;
    this.empleadoService.completarRecordatorios(this.recordatorios.filter((data => data.completado === 0)))
    .subscribe(res => {
      this.modals.correctoModalJquery('Recordatorio completado', 'green', 'modern', 'fa fa-clock-o');
      this.recordatorios = res;
      this.completado = true;
      setTimeout(() => this.loading = false, 1);
    });
  }

  navigate(ID_CLIENTE) {
    localStorage.setItem('recordatorio', ID_CLIENTE);
    this.route.navigate(['/cliente', ID_CLIENTE]);
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/recordatorios/recordatorios.component.ts